import type { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  error?: string;
  helperText?: string;
}

const Input = ({
  id,
  label,
  error,
  helperText,
  className = '',
  ...rest
}: InputProps) => {
  const inputClasses =
    `form-control ${error ? 'is-invalid' : ''} ${className}`.trim();

  return (
    <div className="form-floating mb-3">
      <input
        id={id}
        className={inputClasses}
        placeholder={rest.placeholder || label}
        aria-label={label}
        aria-invalid={!!error}
        aria-describedby={
          error ? `${id}-error` : helperText ? `${id}-help` : undefined
        }
        {...rest}
      />
      <label htmlFor={id}>{label}</label>
      {helperText && !error && (
        <div id={`${id}-help`} className="form-text nova-helper-text">
          {helperText}
        </div>
      )}
      {error && (
        <div id={`${id}-error`} className="invalid-feedback">
          {error}
        </div>
      )}
    </div>
  );
};

export default Input;
